module.exports = __webpack_public_path__ + "img/conference5.51ddf1c9.png";